import { render } from "./HelpDuplicatePart.vue?vue&type=template&id=61b7ffd6"
import script from "./HelpDuplicatePart.vue?vue&type=script&lang=js"
export * from "./HelpDuplicatePart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__